module.exports = __webpack_public_path__ + "static/img/tianjian3.0465b77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caseDetail/tianjian3.png
// module id = Y5+I
// module chunks = 19